import React from 'react'
import styles from './styles.module.css'
import Tooltip from '@mui/material/Tooltip'
import infoIcon from '../Images/circle-info-regular-full.svg'

function JobLocation ({
  localTitle,
  setLocalTitle,
  localCurrentCompany,
  setLocalCurrentCompany
}) {
  const handleTitleChange = event => {
    setLocalTitle(event.target.value)
  }

  const handleCompanyChange = event => {
    setLocalCurrentCompany(event.target.value)
  }

  return (
    <div className={styles.JobLocationSection}>
      <h1 className={styles.JobLocationTitle}>Job</h1>

      <div className={styles.JobLocationInputContainer}>
        {/* Current title */}
        <div className={styles.JobLocationInputWrapper}>
          <div className={styles.labelWithIcon}>
            <label className={styles.JobLocationLabel} htmlFor='currentTitle'>
              Current title
            </label>
            <Tooltip
              title="The person’s present job title."
              arrow
              placement='top'
              slotProps={{
                popper: {
                  sx: {
                    '& .MuiTooltip-tooltip': {
                      maxWidth: 500,
                      fontSize: '13px',
                      padding: '8px'
                    }
                  }
                }
              }}
            >
              <img
                src={infoIcon}
                alt='Current title help'
                width={14}
                height={14}
                className={styles.infoIcon}
                tabIndex={0}
              />
            </Tooltip>
          </div>
          <input
            className={styles.JobLocationInput}
            type='text'
            id='currentTitle'
            placeholder='Text'
            value={localTitle}
            onChange={handleTitleChange}
          />
        </div>

        {/* Current company */}
        <div className={styles.JobLocationInputWrapper}>
          <div className={styles.labelWithIcon}>
            <label className={styles.JobLocationLabel} htmlFor='currentCompany'>
              Current company
            </label>
            <Tooltip
              title="The company or organization where the person is currently employed."
              arrow
              placement='top'
              slotProps={{
                popper: {
                  sx: {
                    '& .MuiTooltip-tooltip': {
                      maxWidth: 500,
                      fontSize: '13px',
                      padding: '8px'
                    }
                  }
                }
              }}
            >
              <img
                src={infoIcon}
                alt='Current company help'
                width={14}
                height={14}
                className={styles.infoIcon}
                tabIndex={0}
              />
            </Tooltip>
          </div>
          <input
            className={styles.JobLocationInput}
            type='text'
            id='currentCompany'
            placeholder='Text'
            value={localCurrentCompany}
            onChange={handleCompanyChange}
          />
        </div>
      </div>
    </div>
  )
}

export default JobLocation
